import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/fotile.png'


const _withScopeId = n => (_pushScopeId("data-v-28ac96fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-header clearfix" }
const _hoisted_2 = {
  class: "image-icon",
  href: "/"
}
const _hoisted_3 = ["width"]
const _hoisted_4 = { class: "right-menu" }
const _hoisted_5 = {
  key: 0,
  class: "medium-item"
}
const _hoisted_6 = { class: "el-dropdown-link" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "dot" }, null, -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode("垂媒失效 ")
const _hoisted_9 = { class: "mas-dropdown-menu" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "iconfont icon-dianhua" }, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 未接来电： ")
const _hoisted_12 = { class: "item work" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("班")
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderbarIcon = _resolveComponent("HeaderbarIcon")!
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_AccountInformation = _resolveComponent("AccountInformation")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_vacation_calendar = _resolveComponent("vacation-calendar")!
  const _directive_perm = _resolveDirective("perm")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.isShrink ? 'l-part l-partActive' : 'l-part')
    }, [
      _createElementVNode("a", _hoisted_2, [
        _createElementVNode("img", {
          style: {"width":"3.8rem","height":"0.8rem"},
          src: _imports_0,
          width: _ctx.isShrink ? 50 : 100,
          alt: "logo"
        }, null, 8, _hoisted_3)
      ])
    ], 2),
    (_openBlock(), _createBlock(_component_HeaderbarIcon, {
      isShrink: _ctx.isShrink,
      onShrink: _ctx.shrink,
      key: _ctx.updateKey
    }, null, 8, ["isShrink", "onShrink"])),
    _createElementVNode("ul", _hoisted_4, [
      (_ctx.verticalMedium.length)
        ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
            _createVNode(_component_el_dropdown, { trigger: "click" }, {
              dropdown: _withCtx(() => [
                _createVNode(_component_el_dropdown_menu, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.verticalMedium, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                          key: index,
                          onClick: ($event: any) => (_ctx.openVerification(item))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_6, [
                  _hoisted_7,
                  _hoisted_8,
                  _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_arrow_down)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.missedCallObj?.num)
        ? (_openBlock(), _createElementBlock("li", {
            key: 1,
            class: "missed-call",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.missedCallPage && _ctx.missedCallPage(...args)))
          }, [
            _hoisted_10,
            _createElementVNode("span", null, [
              _hoisted_11,
              _createElementVNode("b", null, _toDisplayString(_ctx.missedCallObj?.num > 99 ? '99+' : _ctx.missedCallObj?.num), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.cmvccSeat)
        ? (_openBlock(), _createElementBlock("li", {
            key: 2,
            class: "hbb-login-status",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.againLoginSip && _ctx.againLoginSip(...args)))
          }, [
            _createElementVNode("b", {
              class: _normalizeClass({
            down: _ctx.getState === 0,
            up: _ctx.getState === 1,
          })
            }, null, 2),
            _createElementVNode("span", {
              class: _normalizeClass({
            down: _ctx.getState === 0,
            up: _ctx.getState === 1,
          })
            }, _toDisplayString(['离线', '在线'][_ctx.getState]), 3)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_popover, {
        visible: _ctx.accountInfoVisible,
        "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.accountInfoVisible) = $event)),
        placement: "bottom",
        trigger: "manual",
        "popper-class": "hbb-work-fff",
        width: 600
      }, {
        reference: _withCtx(() => [
          _createElementVNode("li", {
            class: "item",
            id: "account-username",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.accountInfoVisible = true))
          }, _toDisplayString(_ctx.user?.currentRole.name) + "：" + _toDisplayString(_ctx.user?.displayName), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_AccountInformation, {
            onSafeExitEvent: _ctx.safeExit,
            onCloseAccountEvent: _cache[3] || (_cache[3] = ($event: any) => (_ctx.accountInfoVisible = false))
          }, null, 8, ["onSafeExitEvent"])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_el_popover, {
        placement: "bottom",
        ref: "popverRef",
        "popper-class": "hbb-work-fff work-calendar",
        title: "休假日历",
        width: "720px",
        trigger: "click",
        onShow: _ctx.showPopver
      }, {
        reference: _withCtx(() => [
          _withDirectives((_openBlock(), _createElementBlock("li", _hoisted_12, _hoisted_14)), [
            [_directive_perm, 'Mgr.Personal.Center.Holiday.Active']
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_vacation_calendar, {
            ref: "vacationCalendar",
            onCalendarEvent: _ctx.safeCalendar,
            onQueryDateEvent: _ctx.queryHolidays,
            holidayList: _ctx.holidayList
          }, null, 8, ["onCalendarEvent", "onQueryDateEvent", "holidayList"])
        ]),
        _: 1
      }, 8, ["onShow"])
    ])
  ]))
}